<template>
  <div class="home">
    <Mains></Mains>
    <Main></Main>
    <Aboutus></Aboutus>
    <Howtouse></Howtouse>
    <paymentMethod></paymentMethod>
    <Location></Location>
    <Hardware></Hardware>
    <Advantages></Advantages>
    <Partner></Partner>
    <Freedom></Freedom>
    <Cooperate></Cooperate>
  </div>
</template>

<script>
import Mains from "./header/mains.vue";
import Main from "./header/main.vue";
import Aboutus from "./aboutus/aboutus.vue";
import Howtouse from "./howtouse/howtouse.vue";
import paymentMethod from "./payment-method/payment-method.vue";
import Location from "./location/index.vue";
import Hardware from "./hardware/hardware.vue";
import Advantages from "./advantages/advantages.vue";
import Partner from "./partner/partner.vue";
import Freedom from "./freedom/freedom.vue";
import Cooperate from "./cooperate/cooperate.vue";

export default {
  name: "HomeComponent",
  components: {
    Mains,
    Main,
    Aboutus,
    Howtouse,
    paymentMethod,
    Location,
    Hardware,
    Advantages,
    Partner,
    Freedom,
    Cooperate,
  },
};
</script>

<style scoped>
.home {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background-color: #f7f8f9;
  font-family: "PingFang SC", "PingFang TC";
  padding-top: 62px;
}
</style>
